import { Component, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LeaClient, LeaStaffClient } from '../services/api.service';
import { catchValidationErrors } from '../utilities/validator-utilities';
import { JwtService } from 'src/auth/services/jwt.service';

@Component({
  selector: 'cert-lea-rush-contact-modal',
  standalone: false,
  templateUrl: './lea-rush-contact-modal.component.html',
  styles: ``,
})
export class LeaRushContactModalComponent {
  @ViewChild('bestContactEmailAddressForm') form!: NgForm;
  personId!: number | undefined;
  applicationServiceItemId!: number;
  caller!: LeaRushCaller;

  bestContactEmailAddress!: string;

  errorEmitter = new EventEmitter<any>();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly leaStaffClient: LeaStaffClient,
    private readonly jwtService: JwtService,
    private readonly leaClient: LeaClient,
  ) {
    this.bestContactEmailAddress = jwtService.getUserEmail() ?? '';
  }

  onSubmit() {
    const request = this.rushServiceItem();

    if (!request) return;

    request.pipe(catchValidationErrors(this.form, this.errorEmitter)).subscribe(() => {
      this.activeModal.close(true);
    });
  }

  rushServiceItem() {
    switch (this.caller) {
      case LeaRushCaller.Lea:
        return this.leaClient.rushServiceItem({
          applicationServiceItemId: this.applicationServiceItemId,
          personId: this.personId!,
          bestContactEmailAddress: this.bestContactEmailAddress,
        });
      case LeaRushCaller.Lea2:
        return this.leaStaffClient.rushServiceItem({
          applicationServiceItemId: this.applicationServiceItemId,
          personId: this.personId!,
          bestContactEmailAddress: this.bestContactEmailAddress,
        });
      default:
        return undefined;
    }
  }

  onClose(): void {
    this.activeModal.close(false);
  }
}

export enum LeaRushCaller {
  Lea,
  Lea2,
}
